import React, { useContext } from 'react';
import { View, Text, Modal } from 'react-native';
import { Icon, Button } from 'react-native-elements';
import { useTranslation } from 'react-i18next';

import useMediumScreen from 'hooks/useMediumScreen';
import OrderContext from 'contexts/OrderContext';
import ModalData from 'types/models/ModalData';

import { styles } from 'styles/components/customModal';

interface CustomModalProps {
  modalData: ModalData | null;
  children: React.ReactNode;
  onClose: () => void;
}

const CustomModal = ({ modalData, children, onClose }: CustomModalProps): JSX.Element => {
  const { t } = useTranslation();
  const mediumScreen = useMediumScreen();
  const { currentOrder } = useContext(OrderContext);
  const { currentVenue } = React.useContext(OrderContext);

  const isVisible = !!modalData;

  if (!modalData) return <></>;

  return (
    <Modal visible={isVisible} transparent>
      <View style={styles.container}></View>

      <View style={styles.modalBox}>
        <View style={[styles.contentCtn, { width: mediumScreen ? '30%' : '80%' }]}>
          <View style={[styles.modaIconContainer, { backgroundColor: modalData.generalColor ?? '#FFFFFF' }]}>
            <Icon
              name={currentOrder ? 'shopping-cart' : 'help-circle-outline'}
              type={currentOrder ? undefined : 'ionicon'}
              color="#FFFFFF"
              size={35}
              containerStyle={styles.iconContainer}
            />
          </View>

          <Text style={styles.title}>{modalData.description}</Text>

          <View style={styles.childrenCtn}>{children}</View>

          <Button
            title={t('close')}
            containerStyle={[[mediumScreen ? styles.btnContainerLarge : styles.btnContainerSmall]]}
            titleStyle={styles.btnPrintTitle}
            buttonStyle={[styles.printBtn, { borderColor: currentVenue?.appColor ?? '#001C47' }]}
            onPress={onClose}
          />
        </View>
      </View>
    </Modal>
  );
};

export default CustomModal;
